<template>
  <div>
    <!--<bread-crumb2 :menu="{name: '런치팩에게 1:1 문의하기',
    desc: '서비스와 관련하여 문의하실 사항, 오류가 발생했을 시 남겨주시면 빠르게 답변드립니다. ' +
     '문의가 필요한 화면을 이미지로 첨부해주시면 더 빠르고 정확한 답변을 드릴 수 있습니다.'}"></bread-crumb2>-->
    <div class="columns is-multiline">
      <div class="column is-6">
        <!-- 저장 -->
        <div class="btn-group-justify-end" v-if="!$route.query.id">
          <button class="button is-primary" @click="saveData">전송</button>
        </div>
        <div class="box">
          <admin-box-item title="문의 내용"
            tip="빠른 대처가 필요한 심각한 오류 발생시에는 고객센터 담당자 메일이나 전화로 문의해주시기 바랍니다.">
            <div class="columns is-multiline">
              <div class="column is-full" v-if="$route.query.id">
                <admin-form-item label="서비스명">
                  {{ value.service_name }}
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query.id===undefined">
                <admin-form-item label="문의유형*">
                  <span class="select">
                    <select v-model="value.type_id" @change="e => selectType(Number(e.target.value))">
                      <option value="" disabled selected>문의유형</option>
                      <option :value="cat.value" v-for="(cat,idx) in cats" :key="'cat-'+idx">{{ cat.label }}</option>
                    </select>
                  </span>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query.id">
                <admin-form-item label="문의유형">
                  {{ value.cat }}
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query.id">
                <admin-form-item label="작성일">
                  {{ value.created_time }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :label="`${value.type === 6 ? '페이지명' : '제목'}*`">
                  <input v-if="$route.query.id===undefined"
                         class="input"
                         :value="value.title"
                         @input="e=> value.title = e.target.value"
                         type="text"
                         maxlength="30">
                  <div v-else>{{ value.title }}</div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :label="`${value.type === 6 ? '페이지 설명' : '내용'}*`">
                  <textarea class="textarea" v-if="$route.query.id===undefined"
                            v-model="value.content"></textarea>
                  <div v-else style="white-space: pre-line">{{ value.content }}</div>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query.id===undefined">
                <admin-form-item label="첨부파일(이미지, pdf, ppt, doc, xls, hwp)" :isHeaderBlock="true" desc="최대 10개까지 등록 가능합니다.">
                  <div class="flex">
                    <!--<old-input-file :maxLength="10" :files.sync="value.imgs"-->
                                <!--@remove="idx=>removeIndex(value.imgs,idx)"></old-input-file>-->
                    <input-file :value.sync="value.imgs_ext" @setValue="val=>value.imgs=val"></input-file>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="$route.query.id && value.imgs.length>0">
                <admin-form-item label="첨부 파일">
                  <a v-for="(file,idx) in value.imgs" :key="'file-'+idx" style="text-decoration: underline" :href="file" target="_blank" download>
                    <i class="material-icons" style="font-size:16px;vertical-align: middle;color:#999">attach_file</i>
                    {{ `파일${idx+1}.${file.split('.')[file.split('.').length-1]}` }}
                  </a>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-6">
        <div class="box" v-if="$route.query.id">
          <admin-box-item title="런치팩 답변" :useTab="false">
            <div class="columns is-multiline">
              <div class="column is-full">
                <!--<div class="column is-full" v-if="value.answer_time">
                  <admin-form-item label="작성일">
                    {{ value.answer_time }}
                  </admin-form-item>
                </div>

                <div class="column is-full" v-if="value.answer_content">
                  <admin-form-item label="답변 내용">
                    <div class="flex">
                      <div style="margin-right:12px;width:90%">
                        <div v-html="value.answer_content"></div>
                      </div>
                      <div>

                      </div>
                    </div>
                  </admin-form-item>
                </div>-->
                <!-- 댓글 -->
                <admin-form-item label="댓글 목록">
                  <div class="comment-list-box" v-if="comment_list.length>0">
                    <div v-for="(item, idx) in comment_list"
                         :key="'comments'+idx"
                         :class="{'comment-align-right': item.author_type==='user'}"
                         style="margin-bottom:12px">
                      <div>
                        <div class="flex-align" style="font-size:11px">
                          <div :class="{'primary-display-name':item.author_type==='admin'}"
                               v-if="!item.is_internal_comment">{{ item.display_name }}</div>
                          <div v-else>내부 메모</div>
                          <div style="margin-left: 12px">{{ item.created_time }}</div>
                          <div @click="deleteComment(item)"
                               class="unselect"
                               v-if="item.author_type!=='admin'"
                               style="padding-left: 10px;">삭제</div>
                        </div>
                        <div :class="{'flex-end':item.author_type==='user'}">
                          <div class="comment-div" :class="{'flex-end':item.author_type==='user'}">
                            <div>{{ item.content }}</div>
                            <div v-if="item.author_type==='admin' && item.imgs && item.imgs.length > 0" style="margin-top: 8px">
                              <a v-for="(file,idx) in item.imgs" :key="'file-'+idx"
                                style="white-space: nowrap; text-decoration: underline" :style="fileStyle(item.imgs, idx)"
                                :href="file" target="_blank" download>
                                <i class="material-icons" style="font-size:16px;vertical-align: middle;color:#999">attach_file</i>
                                {{ `파일${idx+1}.${file.split('.')[file.split('.').length-1]}` }}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>댓글이 없습니다.</div>
                </admin-form-item>

                <admin-form-item label="댓글 작성">
                  <div class="flex">
                    <div style="margin-right:12px;width:90%">
                      <textarea class="textarea" v-model="comments.content"></textarea>
                    </div>
                    <div>
                      <button class="button is-primary"
                              style="height: 100% !important"
                              @click="regComment">등록
                      </button>
                    </div>
                  </div>
                </admin-form-item>
              </div>

              <div class="column is-full" v-if="value.answer_imgs.length>0">
                <admin-form-item label="첨부 파일">
                  <div v-for="(file,idx) in value.answer_imgs" :key="`img-${idx}`" class="column is-full">
                    <a style="text-decoration: underline" :href="file" target="_blank" download>
                      {{ file }}
                    </a>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
    <modal-alert ref="alert" @close="onClose">
      <div class="subtitle4 main">건의사항이 등록되었습니다.<br>무료체험 <span class="primary">7</span>일을 더 드렸어요.</div>
    </modal-alert>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import InputImg from "../../../module/common/InputImg";
  import BreadCrumb2 from "../../../module/common/BreadCrumb2";
  import CreateMixin from '@/mixins/CreateMixin';
  import OldInputFile from "../../../module/common/OldInputFile";
  import InputFile from "../../../module/common/InputFile";
  import ModalAlert from "../../../module/modal/ModalAlert";

  export default {
    components: {
      ModalAlert,
      InputFile,
      OldInputFile,
      BreadCrumb2,
      InputImg, draggable},
    mixins: [
      CreateMixin
    ],
    data() {
      return {
        value: {
          title: '',
          content:'',
          imgs: [],
          type_id:'',
          answer_imgs: ['']
        },
        cats: [],
        // 댓글 목록
        comment_list: [],
        comments: {
          id: "", // 상품문의상세 게시글 id
          content: "",
          is_internal_comment: false  // 내부 메모 여부
        }
      }
    },
    created(){

      this.getData();
      this.getCommentList();
    },
    methods: {
      fileStyle(imgs, idx) {
        let deco = {
          marginBottom: '8px'
        }
        if (idx === imgs.length - 1) {
          deco.marginBottom = '0px';
        }
        return deco;
      },
      selectType(value) {
        if(this.value.content.trim() === '') {
          if(value === 1) {
            this.value.content =
              `OS,기기 (Windows / MacOS / 휴대폰 기종) :
브라우저(크롬, 사파리, 엣지, 웨일) :
오류 발생 / 수정 할 페이지 및 위치 :
오류 발생 / 수정 할 상황 (유저가 요청한 경우, 유저 아이디 필요)

`
          }
          else if(value === 18) {
            this.value.title = '페이플 PG 계약 신청'
            this.value.content =
              `상호명 :
사업자등록번호 :
기업구분(개입/법인/기타) :
대표자명 :
대표자 휴대폰번호 :
대표자 이메일주소 :
주요판매상품(판매 서비스 유형): `
          }
        }
      },
      updateComment (item) {
        this.comments.id = item.id;
        this.comments.content = item.content;
      },
      deleteComment (item) {
        this.$axios.delete(`admin/launchpack/inquiry/customer/${this.$route.query.id}/comment/${item.id}`)
          .then(res=>{
            if(res.status===200){
              this.toast('삭제되었습니다.');
              this.getCommentList();
            }
          })
      },
      getCommentList() {
        if(this.$route.query.id) {
          this.$axios.get(`admin/launchpack/inquiry/customer/${this.$route.query.id}/comment`)
          .then(res => this.comment_list = res.data)
        }
      },
      regComment () {
        if(!this.comments.content) {
          this.toast('댓글을 작성해주세요.');
          return;
        }
        if(this.comments.id) {
          this.$axios.patch(`admin/launchpack/inquiry/customer/${this.$route.query.id}/comment/${this.comments.id}`, this.comments).then(res=>{
            if(res.status===200) {
              this.toast('수정이 완료되었습니다.');
              this.getCommentList();
            }
          })
        }
        else {
          this.$axios.post(`admin/launchpack/inquiry/customer/${this.$route.query.id}/comment`, this.comments).then(res=>{
            if(res.status===200) {
              this.toast('저장이 완료되었습니다.');
              this.comments = {
                id: "",
                content: "",
                is_internal_comment: false
              }
              this.getCommentList();
            }
          })
        }
      },
      getCategory() {
        this.$axios.get(this.masterBackendUrl + 'public/launchpack/inquiry/customer/category').then(res=>{
          res.data = res.data.sort((a,b) => a.label === '기타' ? -1 : a.value - b.value);
          res.data.push(res.data.shift());
          this.cats = res.data;
          if(this.$route.query.cat) {
            this.value.type_id = Number(this.$route.query.cat);
            this.selectType(this.value.type_id);
          }
          if(this.$route.query.app_porting) {
            this.value.title = `${this.$route.query.app_porting === 'android' ? '안드로이드' : 'IOS'} 앱포팅 신청`;
          }
        })
      },
      getData(){
        this.getCategory();
        if(this.$route.query.id){
          this.$axios.get('admin/launchpack/inquiry/customer/'+this.$route.query.id)
            .then(res=>{
              this.value = res.data;

              this.$root.$emit('showCustomerInquiryDetail');
            })
        }
      },
      saveData() {
        let err = '';
        if(!this.value.title) err='제목을 입력하세요.';
        else if(!this.value.content) err='내용을 입력하세요.';
        else if(!this.value.type_id) err='문의 유형을 선택 하세요.';

        if(err) {
          this.toast(err);
          return;
        }
        this.$store.commit('setLoading', true);
        this.$axios.post('admin/launchpack/inquiry/customer', this.value).then((res)=>{
          this.$store.commit('setLoading', false);
          if(res.data.detail.add_trial) {
            this.$axios.get('admin/launchpack/service/info').then(res => {
              this.$store.commit('setMasterServiceInfo', res.data);
            });
            this.$refs.alert.open();
          } else {
            this.toast('문의 내용이 전송되었습니다.');
            this.$router.replace(this.getPath('launchpack/inquiry/customer'));
          }
        })
      },
      onClose() {
        this.$router.replace(this.getPath('launchpack/inquiry/customer'));
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .comment-sub-title
    background #ddd
    color #333
    padding 8px 16px
    font-size 0.95rem
    border-radius 3px
    display flex
    justify-content space-between

  .ask-content
    width 260px
    padding 6px 10px
    font-size .85rem
    color #555
    border-radius 3px
    display inline-block
    border 1px solid #ddd

  .lp-img-bg
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background-color rgba(0,0,0,0.5)
    z-index 100

  .lp-img-full
    position fixed
    top 50%
    left 50%
    transform translate(-50%, -50%)
    max-height 80vh

  .primary-display-name
    color $primary

  .comment-list-box
    border 1px solid #eee
    border-radius 4px
    padding 4px 8px
    margin-bottom 16px
    height 300px
    overflow-y scroll

  .comment-align-right
    display flex
    flex-wrap wrap
    flex-direction row-reverse

  .comment-div
    font-size 13px
    background-color #eee
    border-radius 4px
    padding 4px 8px
    margin 4px 0
    display table
    max-width 100%
    white-space pre-line
</style>
